// Update the src/pages/GlobalSettingsPage.js file

import { useCallback, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { 
  Container, 
  Typography, 
  Alert, 
  Grid, 
  Tab, 
  Tabs, 
  Box 
} from '@mui/material';
import SettingsFrom from '../sections/@dashboard/settings/Form';
import ApiKeyManager from '../sections/@dashboard/settings/ApiKeyManager';
import ZapierIntegration from '../sections/@dashboard/settings/ZapierIntegration';
import { useAuthContext } from '../auth/useAuthContext';
import axios from '../utils/Axios';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function GlobalSettingsPage() {
  const { user, setGlobalUser } = useAuthContext();
  const [success, setSuccess] = useState(null);
  const [tabValue, setTabValue] = useState(0);

  const updateUser = useCallback(async (userData) => {
    const response = await axios.put(`/user`, userData);
    setGlobalUser(response.data.user);
    setSuccess({
      bg: 'success',
      message: 'Settings Updated.',
    });
    setTimeout(() => setSuccess(null), 6000);
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Helmet>
        <title>Global Settings | {localStorage.getItem("companyName") ?? "FlowBookings"}</title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Global Settings
        </Typography>
        
        {success != null && (
          <Alert severity={success.bg} color="info" sx={{ mt: 2, mb: 2 }}>
            {success.message}
          </Alert>
        )}

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="settings tabs">
            <Tab label="General Settings" />
            {/*<Tab label="Integrations" />*/}
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <SettingsFrom config={user.config} updateUser={updateUser} />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <ApiKeyManager />
            </Grid>
            <Grid item xs={12} md={6}>
              <ZapierIntegration />
            </Grid>
          </Grid>
        </TabPanel>
      </Container>
    </>
  );
}